/**
 * @mixin
 */
export default {
  methods: {
    injectScript(url, lib) {
      const el = document.createElement('SCRIPT');
      let ctr = 0;
      let scriptExists = false;

      [...document.getElementsByTagName('script')].forEach(script => {
        scriptExists = script.src === url;
      });

      if (!scriptExists) {
        el.setAttribute('src', url);
        document.body.appendChild(el);
      }

      return new Promise((resolve, reject) => {
        const handle = window.setInterval(() => {
          if (window[lib]) {
            resolve();
            clearInterval(handle);
          }
          ctr += 1;
          if (ctr > 1000) {
            reject(new Error(`Unable to load ${url}`));
            clearInterval(handle);
          }
        }, 5);
      });
    },
    injectScriptCode(scriptId, code, type = 'script') {
      const el = document.createElement(type);
      let scriptExists = false;

      [...document.getElementsByTagName(type)].forEach(script => {
        scriptExists = script.id === scriptId;
      });

      if (!scriptExists) {
        el.id = scriptId;
        el.type = 'text/javascript';
        el.appendChild(document.createTextNode(code));
        document.body.appendChild(el);
      }
    }
  }
};
